import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { derive } from 'derive-zustand';

type State = {
  dimensionsMeta: any;
};

type Action = {
  setDimensionsMeta: (dimensionsMeta: State['dimensionsMeta']) => void;
};

const initialState: State = {
  dimensionsMeta: {},
};

const dimensionsStore = create(
  devtools((set: any, get: any) => ({
    ...initialState,
    setDimensionsMeta: (dimensionsMeta) => set(() => ({ dimensionsMeta })),
  })),
);

export const derivedDimensionsMetaStore: any = derive((get) => {
  const { dimensionsMeta } = get(dimensionsStore);
  const dimensionByTypes = {};
  dimensionsMeta.forEach((dimension) => {
    if (dimension.type) {
      dimensionByTypes[dimension.groupBy] = dimension.type;
    }
  });
  return {
    dimensionByTypes,
  };
});

export default dimensionsStore;
